import React from 'react';
import { IStepRegister } from '../interfaces/IStepRegister';
const registerForm = new IStepRegister();

export default React.createContext(registerForm);